// Copyright (C) 2020 TANNER AG

import { graphql } from "react-apollo";
import { compose } from "recompose";
import withLocalization from "./withLocalization";
import withFlattenedTranslations from "./withFlattenedTranslations";
import withLoadingState from "./withLoadingState";
import withErrorState from "./withErrorState";
import withConnectionStatus from "./withConnectionStatus";
import eMobilityTopicsQuery from "../queries/eMobilityTopics";

const buildQueryOptions = ({ language, fetchPolicy, stage }) => {
    return {
        variables: {
            lang: language.toLowerCase(),
            stage,
        },
        fetchPolicy,
    };
};

export default (customLoadingComponent) =>
    compose(
        withConnectionStatus,
        withLocalization,
        graphql(eMobilityTopicsQuery, {
            options: (props) => {
                return buildQueryOptions(props);
            },
        }),
        withErrorState,
        withLoadingState("eMobilityTopics", customLoadingComponent, customLoadingComponent),
        withFlattenedTranslations("eMobilityTopics")
    );



// WEBPACK FOOTER //
// ./src/hocs/withEMobilityTopics.js